export default __webpack_public_path__ + "static/monika-mihalikova-0858c095ec9b803829e4233a6a5823af.jpg";